module.exports = __webpack_public_path__ + "media/AUDIO-08.862cbf97.mp3";